import { contracts } from '../../data/contracts'

export default {
	name: 'METAL',
	shortName: 'OMETAL',
	contractAddress: contracts[process.env.REACT_APP_NETWORK].metalAddress,
	url: 'http://lorem.com',
	logo: 'tokens/OMetal.png'
}
